module.exports = "data:text/x-markdown;base64,TG9vayBjYXJlZnVsbHkgYXQgdGhlIGNvbnRyYWN0J3MgY29kZSBiZWxvdy4KCllvdSB3aWxsIGJlYXQgdGhpcyBsZXZlbCBpZgoxKSB5b3UgY2xhaW0gb3duZXJzaGlwIG9mIHRoZSBjb250cmFjdAoyKSB5b3UgcmVkdWNlIGl0cyBiYWxhbmNlIHRvIDAKCiZuYnNwOwpUaGluZ3MgdGhhdCBtaWdodCBoZWxwCiogSG93IHRvIHNlbmQgZXRoZXIgd2hlbiBpbnRlcmFjdGluZyB3aXRoIGFuIEFCSQoqIEhvdyB0byBzZW5kIGV0aGVyIG91dHNpZGUgb2YgdGhlIEFCSQoqIENvbnZlcnRpbmcgdG8gYW5kIGZyb20gd2VpL2V0aGVyIHVuaXRzIC1zZWUgaGVscCgpIGNvbW1hbmQtCiogRmFsbGJhY2sgbWV0aG9kcwo="


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/fallback.md
// module id = 1373
// module chunks = 0